const RegionType = {
    408207343: 'KRSL',
    408241936: 'KRDG',
    401190010: 'US',
    404490020: 'EU',
    408690030: 'CN'
}

export default RegionType